export default __webpack_public_path__ + "static/media/frank_oberklaid.c44d3ac4.jpg";